// SlackDateTimePickerWithNav.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SlackDateTimePicker from './SlackDateTimePicker'; 

export default function SlackDateTimePickerWithNav(props) {
  const navigate = useNavigate();
  return <SlackDateTimePicker {...props} navigate={navigate} />;
}
